<template>
  <div id="app">
    <router-view />
  </div>
</template>
<style lang="scss"></style>
<script>
export default {
  name: "App",
  data: function () {
    const { token } = this.$store.getters;
    return {
      token,
    };
  },
  computed: {
    isLogin() {
      return Boolean(this.token);
    },
  },
  provide() {
    const { isLogin } = this;
    return {
      isLogin,
    };
  },
};
</script>
